import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { idFromObject } from '@sorare/core/src/gql/idFromObject';

import useDefaultFilters from '@sorare/marketplace/src/hooks/useDefaultFilters';
import { AdvancedCardSearch } from '@sorare/marketplace/src/searchCards';

import PlayerDetails from '@sorare/gameplay/src/components/player/PlayerDetails';

import { myClubFilters } from 'pages/TransferMarket/cardFilters';

interface Props {
  user: {
    id: string;
    slug: string;
  };
  readOnly?: boolean;
  nbDecks?: number;
}

export const Cards = ({ user, readOnly, nbDecks }: Props) => {
  const { currentUser } = useCurrentUserContext();
  const isCurrentUser = currentUser?.id === user.id;
  const includeCommonCards = isCurrentUser
    ? !currentUser?.userSettings?.hideCommonCards
    : false;

  const showDecksFilter = !readOnly || !!nbDecks;
  const cardFilters = myClubFilters(showDecksFilter);

  const filters = useDefaultFilters({ userId: idFromObject(user.id) });

  return (
    <AdvancedCardSearch
      sport={Sport.FOOTBALL}
      PlayerDetailsComponent={PlayerDetails}
      analyticsTags={['Gallery', 'Football']}
      defaultFilters={filters}
      cardFilters={cardFilters}
      defaultSort="Cards New"
      sorts={[
        'Cards New',
        'Cards Highest Average Score',
        'Cards Highest Price',
        'Cards Lowest Price',
        'Cards Player Name',
      ]}
      includeCommonCards={includeCommonCards}
      hideOwner
      galleryOwnerSlug={user.slug}
      editableLists={!readOnly}
    />
  );
};

export default Cards;
